import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { verkIcon, einIcon, gearIcon, boxIcon } from '@/libs/custom-icons.js'

library.add(faTimes)
// Custom Icons
library.add(verkIcon)
library.add(einIcon)
library.add(boxIcon)
library.add(gearIcon)

// Vue3-Migration Phase 1b: früher globales `Vue.component('v-icon', ...)`, jetzt
// app-scoped Registrierung. Wird aus main.js mit der App-Instanz aufgerufen.
export default function registerFontAwesome(app) {
  app.component('v-icon', FontAwesomeIcon)
}
